















import { defineComponent, computed } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'
import isEmpty from 'lodash/fp/isEmpty'
import FigureBlock from '@/components/feature/PDP/FigureBlock.vue'
import FigureBlockSkeleton from '@/components/global/skeletons/FigureBlockSkeleton.vue'
import { usePdpStore } from '~/store/pdp'
import { useProductStore } from '~/store/product'
import { useCloudflareStore } from '~/store'
import { Figure } from '~/types/product/productTypes'

export default defineComponent({
  components: { FigureBlock, FigureBlockSkeleton },
  props: {},
  setup() {
    const pdpStore = usePdpStore()
    const { selectedApplication } = storeToRefs(pdpStore)
    const productStore = useProductStore()
    const cloudflareStore = useCloudflareStore()

    const images = computed(() => {
      return productStore.currentProduct.data?.attributes.images?.map((image) => {
        return { ...image, cloudflare: cloudflareStore.images[image['dam-media-id']] }
      })
    })

    const onFilteredImages = (filteredArrayOfMappedImages: Figure[]) => {
      if (!isEmpty(filteredArrayOfMappedImages) && selectedApplication.value.code !== 'FUNC') {
        const firstFilteredImage = filteredArrayOfMappedImages.find(
          (image) =>
            image.code === selectedApplication.value.code || image.protocolId === selectedApplication.value.protocolId
        )
        if (firstFilteredImage) {
          pdpStore.setSelectedApplication({
            code: firstFilteredImage.code,
            group: firstFilteredImage.codeForDisplay,
            protocolId: firstFilteredImage.protocolId,
          })
        }
      }
    }

    return { images, selectedApplication, onFilteredImages }
  },
})
